import { Outlet } from "react-router-dom";
import Header from "components/header";

const UserLayout = () => {
  return (
    <>
      <Header />
      <Outlet />
    </>
  );
};

export default UserLayout;
